import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const ExosomePage = lazy(() => import('../pages/exosome/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BusinessSupport = lazy(() => import('../pages/business/support/page'));
const BusinessOEM = lazy(() => import('../pages/business/oem/page'));
const ResearchDevelopment = lazy(() => import('../pages/business/r-d/page'));
const CosmeticIngredients = lazy(() => import('../pages/business/ingredients/page'));
const CellCultivation = lazy(() => import('../pages/business/bringup/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/exosome',
    element: <ExosomePage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/business/support',
    element: <BusinessSupport />,
  },
  {
    path: '/business/oem',
    element: <BusinessOEM />,
  },
  {
    path: '/business/r-d',
    element: <ResearchDevelopment />,
  },
  {
    path: '/business/ingredients',
    element: <CosmeticIngredients />,
  },
  {
    path: '/business/bringup',
    element: <CellCultivation />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
